var _rect, _ellipse, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarEventMegatron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#FBEEEE"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.6673,
    cy: 21.3333,
    rx: 1.33333,
    ry: 1.33333,
    stroke: "#641616",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.3333,
    cy: 21.3333,
    r: 1.33333,
    stroke: "#641616",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 21.333H13C12.4477 21.333 12 20.8853 12 20.333V17.4812H12.75V14.8674V14.8674C14.9572 13.8639 17.3984 13.4887 19.805 13.783L20.625 13.8833L21.6667 16.6346L24 17.6187V20.333C24 20.8853 23.5523 21.333 23 21.333H22.5",
    stroke: "#641616",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 21.333L20 21.333",
    stroke: "#641616",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarEventMegatron);
export default __webpack_public_path__ + "static/media/CarEventMegatron.ca13bd1662977915574c76cf2df5a653.svg";
export { ForwardRef as ReactComponent };